<template>
    <b-modal id="modal-event" title="Add Event" hide-footer size="lg" centered @hidden="resetModal">
        <validation-observer ref="observer" v-slot="{ handleSubmit, invalid }">
        <b-form @submit.prevent>
            <b-row>
                <!-- Campaign Name -->
                <b-col md="6">
                    <b-form-group label="Event Name" label-for="campaign_name">
                        <validation-provider rules="required" #default="{ errors }" name="campaign name"
                            vid="Campaign Name">
                            <b-form-input v-model="campaignName" :state="errors.length > 0 ? false : null" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group label="Event Description" label-for="campaign_name">
                        <validation-provider rules="required" #default="{ errors }" name="campaign name"
                            vid="Campaign description">
                            <b-form-input v-model="campaignDescription" :state="errors.length > 0 ? false : null" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group label="Event Type" label-for="event_type">
                        <validation-provider rules="required" #default="{ errors }" name="Event Type" vid="Event Type">
                            <b-form-select v-model="eventType" :options="eventTypeOptions"
                                :state="errors.length > 0 ? false : null" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>


                <b-col md="6">
                    <b-form-group label="Assignee" label-for="assignee">
                        <validation-provider rules="required" #default="{ errors }" name="Assignee" vid="Assignee">
                            <b-form-select v-model="Assignee" :options="assignee_options"
                                :state="errors.length > 0 ? false : null" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>



                <!-- Start Date -->
                <b-col md="6">
                    <b-form-group label="Start Date" label-for="start_date">
                        <validation-provider rules="required" #default="{ errors }" name="start date" vid="Start Date">
                            <b-form-datepicker v-model="startDate" id="start_date" placeholder="Choose a date"
                                local="en" :min="currentDate" :state="errors.length > 0 ? false : null" :initial-date="new Date()" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group label=" End Date" label-for="end_date">
                        <validation-provider rules="required" #default="{ errors }" name="end date" vid="End Date">
                            <b-form-datepicker v-model="endDate" id="end_date" placeholder="Choose a date" local="en"
                            :min="startDate || currentDate" :state="errors.length > 0 ? false : null" :initial-date="new Date()" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>

                <!-- Subject -->
                <b-col md="6">
                    <b-form-group label="Budget" label-for="budget">
                        <validation-provider rules="required|numeric|min_value:1" #default="{ errors }" name="cost" vid="cost">
                            <b-form-input type="number" v-model="cost" placeholder="Enter budget"
                                name="cost" :state="errors.length > 0 ? false : null" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group label="Status" label-for="status">
                        <validation-provider rules="required" #default="{ errors }" name="Status" vid="Status">
                            <b-form-select v-model="Status" :options="statusOptions"
                                :state="errors.length > 0 ? false : null" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>

                <!-- Email Template -->
                <b-col md="6">
                    <b-form-group label="Template" label-for="email_template">
                        <validation-provider #default="{ errors }" name="email template" vid="Email Template">
                            <b-form-select 
                                v-model="selectedTemplateId"
                                :options="templateOptions"
                                @change="selectTemplate"
                                :state="errors.length > 0 ? false : null"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>

                <!-- Subject -->
                <b-col md="12">
                    <b-form-group label="Subject" label-for="subject">
                        <validation-provider  #default="{ errors }" name="subject" vid="Subject">
                            <b-form-input v-model="selectedTemplate.subject" placeholder="Subject" name="subject"
                                :state="errors.length > 0 ? false : null" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>


                <!-- Email Content -->
                <b-col md="12">
                    <b-form-group label="Content" label-for="email_content">
                        <validation-provider  #default="{ errors }" name="content"
                            vid="Email Content">
                            <quill-editor v-model="selectedTemplate.content" :state="errors.length > 0 ? false : null" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>
            </b-row>
            <!-- Submit Button -->
            <b-col md="12" class="d-flex justify-content-end">
                <b-button type="submit" @click="submitCampaignForm" variant="primary">SUBMIT</b-button>
            </b-col>
        </b-form>
        </validation-observer>
    </b-modal>
</template>

<script>
import { BModal, BForm, BFormGroup, BFormSelect, BFormInput, BFormDatepicker, BButton, BCol, BRow, BFormRadio, } from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VSelect from "vue-select";
import { quillEditor } from "vue-quill-editor";
import { mapActions, mapGetters } from "vuex";
export default {
    components: {
        BModal,
        BForm,
        BFormGroup,
        BFormSelect,
        BFormInput,
        BFormDatepicker,
        BButton,
        BCol,
        BRow,
        ValidationProvider,
        VSelect,
        quillEditor,
        BFormRadio,
        ValidationObserver,
    },
    data() {
        return {
            campaignDescription: "",
            campaignId: this.$route.params.id,
            platformName: "Event",
            eventType: "",
            Assignee: "",
            Status: "",
            assignee_options: [],
            campaignName: "",
            campaignOptions: [],
            startDate: null,
            endDate: null,
            selectedTemplateId: null,
            emailtemplatelist: [],
            selectedProvider: null,
            smtp: [],
            selectedSegments: [],
            segmentOptions: [],
            selectedTemplate: {
                subject: "",
                content: ""
            },
            currentDate: new Date().toISOString().split("T")[0],
            statusOptions: [
                { value: 'PENDING', text: 'Pending' },
                { value: 'COMPLETED', text: 'Completed' },
                { value: 'INPROGRESS', text: 'In Progress' },
                { value: 'ONHOLD', text: 'On Hold' },
                { value: 'CANCELLED', text: 'Cancelled' },
                { value: 'DRAFT', text: 'Draft',selected: true }
            ],
            eventTypeOptions: [
                { value: 'face-to-face', text: 'Face to face' },
                { value: 'radio', text: 'Radio' },
                { value: 'tv', text: 'TV' },
                { value: 'billboard', text: 'Billboard' },
                { value: 'newspaper', text: 'Newspaper' },
                { value: 'press-release', text: 'Press Release' },
                { value: 'video-campaign', text: 'Video Campaign' },
                { value: 'audio-campaign', text: 'Audio Campaign' }
            ],
            SelectedRadio: "D",
            links: [""],
            quillOptions: {
                theme: "snow", // Use 'snow' theme for basic styling
                modules: {
                    toolbar: [
                        ["bold", "italic", "underline", "strike"], // Formatting buttons
                        [{ list: "ordered" }, { list: "bullet" }], // List buttons
                        [{ align: [] }], // Alignment buttons
                        ["clean"], // Remove formatting button
                    ],
                },
            },
        };
    },

    computed: {
        ...mapGetters("marketingModule", {
            appid: "appid",
            campaignId: "campaignId",
            posts: "drafts",
            eventsTaskslist: "eventtasks",
            loadingMarketing: "loading",
            marketingTemplate: "marketingTemplate",
        }),
        templateOptions() {
        return this.emailtemplatelist.length > 0 
            ? this.emailtemplatelist 
            : [{ value: 0, text: "NO TEMPLATE AVAILABLE", disabled: true }];
    }
    },
    async mounted() {
        await this.getContentTemplateAction(this.platformName).then(() => {

this.emailtemplatelist = this.marketingTemplate.map((template) => ({
    value: template.id,
    text: `${template.name}`,
    content: template.content || "",
    subject: template.subject || "",
}));

console.log("Dropdown Data (All Items):", this.emailtemplatelist);
});
        try {
            const assignee_response = await this.getAssigneeListAction();
            console.log("Raw API response for assignees event:", assignee_response);

            if (Array.isArray(assignee_response) && assignee_response.length > 0) {
                this.assignee_options = assignee_response.map(assignee => ({
                    value: assignee.id,
                    text: `${assignee.firstName} ${assignee.lastName}`
                }));
            } else {
                console.warn("No assignees found or unexpected format", assignee_response);
                this.assignee_options = [];
            }
        } catch (error) {
            console.error("Error fetching assignees:", error);
            this.assignee_options = [];
        }
    },
    methods: {
        ...mapActions("marketingModule", [
            "getAppIdAction",
            "getPostAction",
            "removePostAction", "postSocialAction",
            "postMarketingCampaignAction",
            "getMarketingCampaignByIDAction",
            "putMarketingCampaignAction",
            "getCampaignDraftListAction", "postCampaignDraftAction",
            "getEventTaskListAction", "postEventTaskAction", "putEventTaskAction", "getContentTemplateAction"
        ]),
        ...mapActions("marketingModule", [
            "getAssigneeListAction"
        ]),
        selectTemplate() {

            if (this.selectedTemplateId) {
           const template = this.emailtemplatelist.find(
        (template) => template.value === this.selectedTemplateId
    );

    if (template) {
        console.log("Template Found:", template);

        // Assign template properties
        this.selectedTemplate = { ...template };

            // ✅ Ensure Vue reactivity
        this.$set(this.selectedTemplate, "content", this.selectedTemplate.content || "");
        this.$set(this.selectedTemplate, "subject", this.selectedTemplate.subject || "");

    } else {
        console.warn("Template not found!");
        this.selectedTemplate = { subject: "", content: ""};
    }

       // Preserve the budget value if it was already entered
        this.selectedTemplate = {
            ...selected,
            cost: this.selectedTemplate.cost || ""
        };
    }
    },

        resetModal() {
        this.campaignDescription = "";
        this.campaignName = "";
        this.eventType = "";
        this.Assignee = "";
        this.Status = "";
        this.startDate = null;
        this.endDate = null;
        this.selectedTemplate.subject = "";
        this.selectedTemplate = {
            subject: "",
            content: ""
        };
        this.selectedTemplateId = null;
    },
        async submitCampaignForm() {
            // Logic to handle form submission
            // alert("Campaign saved successfully");
            // this.$bvModal.hide("modal-campaign");
            let isValid = await this.$refs.observer.validate();
           if (isValid) {

            let loader = this.$swal({
                title: "Processing...",
                text: "Please wait while the draft is being added",
                onOpen: () => {
                    this.$swal.showLoading();
                },
                allowOutsideClick: () => !this.$swal.isLoading(),
                buttonsStyling: false,
                showConfirmButton: false,
            });
             
            const payload = {
                campaignId: this.campaignId,
                name: this.campaignName,
                platformType: this.eventType,
                assignee: this.assignee,
                startDate: this.startDate,
                endDate: this.endDate,
                budget: this.cost,
                status: this.Status,
                platform: "Event",
                subject: this.selectedTemplate.subject,
                content: this.selectedTemplate.content,
            };
            console.log("payload event:", payload),
            this.postCampaignDraftAction(payload)
                .then((response) => {
                    this.$swal("Success", "Draft added successfully!", "success");
                    console.log("Cost added successfully:", response);
                    loader.close();

                    // Reset the form
                    this.newCost = {
                        campaignId: this.campaignId,
                        category: "",
                        description: "",
                        amount: null,
                        date: "",
                    };

                    // Hide the modal
                    this.$emit("content-updated");
                    this.$bvModal.hide("modal-event");

                    // Show success notification
                    this.success("draft added successfully!");
                    this.refreshCostTable();
                })
                .catch((error) => {
                    console.error("Error adding draft:", error);
                    loader.close();
                    this.error("Failed to add draft. Please try again.");
                });
            } else {
                this.error("Failed to add draft. Please try again.");
            }
        },
        
        addLink() {
            if (this.links.length < 3) {
                this.links.push(""); // Add a new empty input field
            }
        },
        removeLink(index) {
            this.links.splice(index, 1); // Remove the selected input field
        },
        setFormData(item) {
            if (item) {
                this.campaignName = item.name || "";
                this.cost = item.budget || "";
                this.content = item.content || "";

                // Extract link from mediaDetails safely
                let mediaDetails = [];
                try {
                    mediaDetails = JSON.parse(item.mediaDetails || "[]");
                } catch (error) {
                    console.error("Error parsing media details:", error);
                }
                this.link = mediaDetails.length > 0 ? mediaDetails[0].Url.replace(/["]/g, '') : "";
                this.mediaType = mediaDetails.length > 0 ? mediaDetails[0].MediaType : "image";


            }
        },
    }
};
</script>

<style>
.item-selector-title {
    width: 100%;
}
</style>